/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ViewerBookResponseModel,
  ViewerEpisodeModel,
  ViewerPagesResponseModel,
} from '../models/index';
import {
    ViewerBookResponseModelFromJSON,
    ViewerBookResponseModelToJSON,
    ViewerEpisodeModelFromJSON,
    ViewerEpisodeModelToJSON,
    ViewerPagesResponseModelFromJSON,
    ViewerPagesResponseModelToJSON,
} from '../models/index';

export interface GetViewerBookByViewerIdRequest {
    viewerId: string;
}

export interface GetViewerEpisodesByViewerIdRequest {
    viewerId: string;
}

export interface GetViewerPagesByViewerIdRequest {
    viewerId: string;
    pageFrom: number;
    pageTo: number;
    xComiciUserToken?: string;
}

/**
 * 
 */
export class ViewerApi extends runtime.BaseAPI {

    /**
     * viewer_id に紐づく作品情報(vi_books) を返却します
     * ビューア用API作品1件取得
     */
    async getViewerBookByViewerIdRaw(requestParameters: GetViewerBookByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViewerBookResponseModel>> {
        if (requestParameters.viewerId === null || requestParameters.viewerId === undefined) {
            throw new runtime.RequiredError('viewerId','Required parameter requestParameters.viewerId was null or undefined when calling getViewerBookByViewerId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/viewer/books/{viewer_id}`.replace(`{${"viewer_id"}}`, encodeURIComponent(String(requestParameters.viewerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewerBookResponseModelFromJSON(jsonValue));
    }

    /**
     * viewer_id に紐づく作品情報(vi_books) を返却します
     * ビューア用API作品1件取得
     */
    async getViewerBookByViewerId(requestParameters: GetViewerBookByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViewerBookResponseModel> {
        const response = await this.getViewerBookByViewerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * viewer_id に紐づくエピソード情報(vi_episodes)のリストを返却します
     * ビューア用APIエピソードリスト取得
     */
    async getViewerEpisodesByViewerIdRaw(requestParameters: GetViewerEpisodesByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ViewerEpisodeModel>>> {
        if (requestParameters.viewerId === null || requestParameters.viewerId === undefined) {
            throw new runtime.RequiredError('viewerId','Required parameter requestParameters.viewerId was null or undefined when calling getViewerEpisodesByViewerId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/viewer/episodes/{viewer_id}`.replace(`{${"viewer_id"}}`, encodeURIComponent(String(requestParameters.viewerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ViewerEpisodeModelFromJSON));
    }

    /**
     * viewer_id に紐づくエピソード情報(vi_episodes)のリストを返却します
     * ビューア用APIエピソードリスト取得
     */
    async getViewerEpisodesByViewerId(requestParameters: GetViewerEpisodesByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ViewerEpisodeModel>> {
        const response = await this.getViewerEpisodesByViewerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * viewer_id に紐づくページ情報(vi_drm_images)のリストを返却します
     * ビューア用APIページリスト取得
     */
    async getViewerPagesByViewerIdRaw(requestParameters: GetViewerPagesByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViewerPagesResponseModel>> {
        if (requestParameters.viewerId === null || requestParameters.viewerId === undefined) {
            throw new runtime.RequiredError('viewerId','Required parameter requestParameters.viewerId was null or undefined when calling getViewerPagesByViewerId.');
        }

        if (requestParameters.pageFrom === null || requestParameters.pageFrom === undefined) {
            throw new runtime.RequiredError('pageFrom','Required parameter requestParameters.pageFrom was null or undefined when calling getViewerPagesByViewerId.');
        }

        if (requestParameters.pageTo === null || requestParameters.pageTo === undefined) {
            throw new runtime.RequiredError('pageTo','Required parameter requestParameters.pageTo was null or undefined when calling getViewerPagesByViewerId.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageFrom !== undefined) {
            queryParameters['page-from'] = requestParameters.pageFrom;
        }

        if (requestParameters.pageTo !== undefined) {
            queryParameters['page-to'] = requestParameters.pageTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/viewer/pages/{viewer_id}`.replace(`{${"viewer_id"}}`, encodeURIComponent(String(requestParameters.viewerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewerPagesResponseModelFromJSON(jsonValue));
    }

    /**
     * viewer_id に紐づくページ情報(vi_drm_images)のリストを返却します
     * ビューア用APIページリスト取得
     */
    async getViewerPagesByViewerId(requestParameters: GetViewerPagesByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViewerPagesResponseModel> {
        const response = await this.getViewerPagesByViewerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
